module.exports = __webpack_public_path__ + "static/media/transcosta.3375d9c3.png";